// The dashed, unlabelled link from a data-source pill to its agent step. Not
// interactive: it carries no condition, and the pill is what gets clicked.

import { BaseEdge, getBezierPath, type EdgeProps } from "@xyflow/react";
import type { DataSourceEdge as DataSourceEdgeType } from "./types.ts";

export default function DataSourceEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}: EdgeProps<DataSourceEdgeType>) {
  const [path] = getBezierPath({ sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition });
  const stroke =
    data?.configured === false ? "var(--mui-palette-warning-main)" : "var(--mui-palette-text-disabled)";
  return (
    <BaseEdge
      id={id}
      path={path}
      interactionWidth={0}
      style={{ stroke, strokeWidth: 1.25, strokeDasharray: "4 4" }}
    />
  );
}
